export default __webpack_public_path__ + "static/media/maxresdefault.78514fa3.jpg";